module.exports = __webpack_public_path__ + "img/symbol_13_free.6bd6c899.png";